import styled from 'styled-components';
import {UsefulLinksItemDefaultBox} from './useful-links-item.default.box';

export const UsefulLinksItemCipBox = styled(UsefulLinksItemDefaultBox)`
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        padding-left: 0;
        text-transform: uppercase;
        ${({theme}) => theme.font.presets.medium};
        &:first-child {
            margin-top: 0;
            border-top: 0;
        }
    }
`;
